import { getEffectiveTranslations } from './i18n';

function t(lang, key) { return getEffectiveTranslations(lang||'en')[key]||key; }

// ── BeeLove CMS — Static page content store ───────────────────────────────
// Each page has sections. Each section has a type: 'hero'|'body'|'steps'|'faq'|'contacts'
// Admin can edit any field. Content is stored per lang in localStorage.
// The StaticPage component reads from here first, then falls back to defaults.

export function getCMSPages(lang) { return [
  { id:'about',   icon:'🐝', label:'About BeeLove' },
  { id:'how',     icon:'🐝', label:t(lang,'cms.how') },
  { id:'privacy', icon:'🔒', label:t(lang,'cms.privacy') },
  { id:'terms',   icon:'📋', label:t(lang,'cms.terms') },
  { id:'safety',  icon:'🛡️', label:t(lang,'cms.safety') },
  { id:'contact', icon:'✉️', label:t(lang,'cms.contact') },
  { id:'pricing', icon:'✨', label:t(lang,'cms.pricing') },
  { id:'help',    icon:'❓', label:t(lang,'cms.help') },
  { id:'press',   icon:'📰', label:t(lang,'cms.press') },
  { id:'careers', icon:'🚀', label:t(lang,'cms.careers') },
];
}
export const CMS_PAGES = getCMSPages('en');

const STORAGE_KEY = (pageId, lang) => `beeloveCMS_${pageId}_${lang}`;

export function loadPageContent(pageId, lang) {
  try {
    const saved = localStorage.getItem(STORAGE_KEY(pageId, lang));
    return saved ? JSON.parse(saved) : null;
  } catch { return null; }
}

export function savePageContent(pageId, lang, content) {
  try {
    localStorage.setItem(STORAGE_KEY(pageId, lang), JSON.stringify(content));
    return true;
  } catch { return false; }
}

export function resetPageContent(pageId, lang) {
  try { localStorage.removeItem(STORAGE_KEY(pageId, lang)); } catch {}
}
